import { Component } from '@angular/core';

@Component({
    selector: 'ca-scroll-top',
    template: '<div class="scroll-top"></div>',
    styleUrls: ['scroll-top.component.less'],
})
export class ScrollTopComponent {}
